// extracted by mini-css-extract-plugin
module.exports = {"switch":"styles_switch__2MDwG","slider":"styles_slider__2DjcJ"};